import React from 'react';
import { Route } from 'react-router-dom';

// Desktop Component
import DesktopMainHeader from '@src/componentsNew/Header/DesktopMainHeader';
import DesktopFooter from '@src/componentsNew/Footer/DesktopFooter';

// Mobile Component
import MobileMainHeader from '@src/componentsNew/Header/MobileMainHeader';
import MobileFooter from '@src/componentsNew/Footer/MobileFooter';
import BottomNavigationBar from '@src/componentsNew/BottomNavigation';

// 레이아웃 컴포넌트
const DesktopLayout = ({ showHeader, showFooter, isHeaderMargin, children }) => {
  return (
    <>
      {showHeader && (
        <>
          <DesktopMainHeader />
          {isHeaderMargin && <div style={{ marginTop: '8rem' }} />}
        </>
      )}
      {children}
      {showFooter && <DesktopFooter />}
    </>
  );
};

const DesktopLayoutRoute = ({
  component: Component,
  showHeader = true,
  showFooter = true,
  isHeaderMargin = true,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => (
      <DesktopLayout showHeader={showHeader} showFooter={showFooter} isHeaderMargin={isHeaderMargin}>
        <Component {...props} />
      </DesktopLayout>
    )}
  />
);

const MobileLayout = ({ showHeader, showFooter, showBottomNav, isHeaderMargin, children }) => {
  return (
    <>
      {showHeader && (
        <>
          <MobileMainHeader />
          {isHeaderMargin && <div style={{ marginTop: '94px' }} />}
        </>
      )}
      {children}
      {showFooter && <MobileFooter />}
      {showBottomNav && <BottomNavigationBar />}
    </>
  );
};

const MobileLayoutRoute = ({
  component: Component,
  showHeader = true,
  showFooter = true,
  showBottomNav = true,
  isHeaderMargin = true,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => (
      <MobileLayout
        showHeader={showHeader}
        showFooter={showFooter}
        showBottomNav={showBottomNav}
        isHeaderMargin={isHeaderMargin}
      >
        <Component {...props} />
      </MobileLayout>
    )}
  />
);

export { DesktopLayoutRoute, MobileLayoutRoute };
